import React from 'react';
import { Link } from 'react-router-dom';

function TabBar({varMenuType}){
  const adminLoginState = Number(localStorage.getItem('adminLoginState'));

  const adminMode = Number(localStorage.getItem("adminMode"));
  const adminMenu= localStorage.getItem("menuAvailables");
  const menuArray = adminMenu.split('|');

  return(
    <div className="admin-top-menu">
      {adminLoginState === 0 ? "" :
        <>
          {adminMode===3?<Link to="/Admin/StaffList" className={varMenuType==="MEMBER"?"selected":""}>직원관리</Link>:null}
          {Number(menuArray[0])===1?<Link to="/Admin/DeliveryList" className={varMenuType==="DELIVERY"?"selected":""}>배차관리</Link>:null}
          {Number(menuArray[1])===1?<Link to="/Admin/DriverList/1" className={varMenuType==="DRIVER"?"selected":""}>기사관리</Link>:null}
          {Number(menuArray[2])===1?<Link to="/Admin/Boards/NoticeList" className={varMenuType==="BOARDS"?"selected":""}>게시판관리</Link>:null}
          {Number(menuArray[3])===1?<Link to="/Admin/Variables" className={varMenuType==="ENVIRONMENT"?"selected":""}>설정관리</Link>:null}
        </>
      }
    </div>
  )
}

export default TabBar;



